import { createFileRoute } from '@tanstack/react-router';
import Perks from 'src/pages/Organization/Players/Perks';

export const Route = createFileRoute(
  '/$organizationSlug/players/$playerId/perks',
)({
  component: Perks,
});
